// Footer layanan pengaduan konsumen (syarat SIUPMSE), tampil di semua halaman: kontak Fola+ dan kontak unit
// Kemendag yang membidangi perlindungan konsumen, dalam satu baris ringkas di atas copyright (Figma desktop).
import { Link } from 'react-router';

import { CUSTOMER_SERVICE_WHATSAPP_DISPLAY, CUSTOMER_SERVICE_WHATSAPP_URL } from '../lib/contact';

/** Kanal pengaduan Ditjen PKTN Kemendag (bukan nomor Fola+); cek ulang di kanal resmi Kemendag sebelum rilis. */
const PKTN_WHATSAPP = '0853-1111-1010';
const PKTN_WHATSAPP_URL = 'https://wa.me/6285311111010';
const PKTN_PHONE = '021-3441839';
const PKTN_PHONE_URL = 'tel:+62213441839';

const CONTACT_LINK = 'font-semibold text-fola-indigo hover:underline';

export function ComplaintFooter({ className = '' }: { className?: string }) {
  return (
    <footer className={`w-full border-t border-slate-100 ${className}`} data-testid="complaint-footer">
      <div className="space-y-1 px-4 py-4 text-[11px] leading-relaxed text-slate-500 sm:px-6 md:px-12">
        <p>
          <strong className="font-bold text-fola-ink">Layanan Pengaduan Konsumen:</strong> WhatsApp Fola+{' '}
          <a
            href={CUSTOMER_SERVICE_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={CONTACT_LINK}
          >
            {CUSTOMER_SERVICE_WHATSAPP_DISPLAY}
          </a>{' '}
          (
          <Link to="/pengaduan" className={CONTACT_LINK}>
            Pengaduan &amp; Keluhan
          </Link>
          ). Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga, Kementerian Perdagangan RI: WhatsApp{' '}
          <a href={PKTN_WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={CONTACT_LINK}>
            {PKTN_WHATSAPP}
          </a>
          , telepon{' '}
          <a href={PKTN_PHONE_URL} className={CONTACT_LINK}>
            {PKTN_PHONE}
          </a>
          .
        </p>
        <p className="text-slate-400">© FOLA+ · Aktivitasmu, manfaatmu.</p>
      </div>
    </footer>
  );
}
